import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { all_routes } from '../../../router/all_routes';
import { getPoliceVerificationStatus } from '../../../../core/data/redux/employeesSlice';

const PoliceVerification: React.FC = () => {
  const dispatch = useDispatch();
  const employeesState = useSelector((state: any) => state.employeesState);

  useEffect(() => {
    dispatch(getPoliceVerificationStatus({}));
  }, [dispatch]);

  const rawData = employeesState?.policeVerificationData?.data || employeesState?.policeVerificationData;
  const item = Array.isArray(rawData) ? rawData[0] : (rawData || {});

  const pvStatus = item?.PVStatus || 'POLICE VERIFICATION RECEIVED';
  const subStatus = item?.SubStatus || 'YES';
  const comment = item?.Comment || 'No adverse';

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Police Verification Status</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.employeeDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Other Services</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Police Verification
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="card shadow-sm">
              <div className="card-header bg-primary text-white">
                <h5 className="card-title mb-0 text-white">
                  <i className="ti ti-shield-check me-2"></i>
                  Police Verification Details
                </h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td className="text-danger fw-semibold" style={{ width: '40%' }}>
                          PV Status:
                        </td>
                        <td className="text-end fw-bold text-dark">
                          {pvStatus}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <hr className="my-2" style={{ borderColor: '#dc3545' }} />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-danger fw-semibold">
                          Sub Status:
                        </td>
                        <td className="text-end fw-bold text-dark">
                          {subStatus}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <hr className="my-2" style={{ borderColor: '#dc3545' }} />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-danger fw-semibold">
                          Comments:
                        </td>
                        <td className="text-end fw-bold text-dark">
                          {comment}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliceVerification;

